import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'admin-console';

  constructor(icons: MatIconRegistry) {
    // outline icons, like the desktop app's line icons (index.html loads both sets)
    icons.setDefaultFontSetClass('material-icons-outlined');
  }
}
